<template>
  <!-- 单品方案设计 -->
  <div class="addFocusBuy"><!-- 页头 -->
    <page-header @back="goBack" :title="$route.meta.title"></page-header>
    <!-- 表单容器 -->
    <el-scrollbar style="width: 100%;height:calc(100% - 60px);padding-top:20px;box-sizing:border-box;">
      <el-form :model="addForm" label-position="right"
        label-width="170px" :rules="addFormRule" ref="addForm">
        <div class="form-item-wrap">
          <el-form-item label="活动名称" prop="name">
            <el-input v-model="addForm.name" style="width: 200px;"></el-input>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="活动商品" prop="goodsId">
            <el-input readonly v-model="addForm.goodsName" style="width:200px;" @click.native="setTableData('goods')" placeholder="单击选择"></el-input>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="单份定金" prop="deposit">
            <el-input-number v-model="addForm.deposit" :min="0"
              style="width:200px;"></el-input-number>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="活动开始时间" prop="startTime">
            <el-date-picker
              v-model="addForm.startTime"
              type="datetime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width:200px;"
              placeholder="选择开始时间">
            </el-date-picker>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="活动结束时间" prop="endTime">
            <el-date-picker
              v-model="addForm.endTime"
              type="datetime"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              style="width:200px;"
              placeholder="选择结束时间">
            </el-date-picker>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="客户类型" prop="userType">
            <el-checkbox-group v-model="addForm.userType" style="width: 1000px">
              <el-checkbox
                v-for="item in userTypeList"
                :key="item.value"
                :label="item.value">
                {{item.label}}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item v-if="addForm.entId" label="支付方式" prop="payType">
            <el-checkbox-group v-if="!isPayTips" v-model="addForm.payType">
              <el-checkbox
                v-for="item in payTypeList"
                :key="item.value"
                :label="item.value">
                {{item.label}}
              </el-checkbox>
            </el-checkbox-group>
            <span v-if="isPayTips" class="payTips">该商品所在机构无支付方式，请先维护支付方式</span>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="达成目标模式" prop="mode">
            <el-radio-group v-model="addForm.mode">
              <el-radio label="1" value="1">满足商品数量</el-radio>
              <el-radio label="2" value="2">满足客户数量</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <!-- <div class="form-item-wrap">
          <el-form-item label="是否启用阶梯价格" prop="isLadder">
            <el-select v-model="addForm.isLadder" placeholder="是否启用阶梯价格" 
              style="width:200px;margin-right:5px">
              <el-option label="否" value="0"></el-option>
              <el-option label="是" value="1"></el-option>
            </el-select>
          </el-form-item>
        </div> -->
        <!-- <div class="form-item-wrap">
          <el-form-item label="阶梯价格条件" prop="ladder" class="el-form-required-true">
            <el-table
              :data="ladderList"
              stripe border
              tooltip-effect="dark"
              style="width: 1000px;border: 1px solid #EBEEF5;border-bottom: none;">
              <el-table-column
                label="序号"
                align="center"
                width="50">
                <template slot-scope="scope">
                  <span>{{scope.$index + 1}}</span>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                show-overflow-tooltip
                :label="'满足' + (addForm.mode == 1 ? '商品' : '客户') + '数量'">
                <template slot-scope="scope">
                  <el-input-number v-if="scope.$index == 0" v-model="addForm.ladder.num" :min="0" style="width:90%;"></el-input-number>
                  <span v-else>{{scope.row.num}}</span>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                show-overflow-tooltip
                label="商品单价">
                <template slot-scope="scope">
                  <el-input-number v-if="scope.$index == 0" v-model="addForm.ladder.price" :min="0" style="width:90%;"></el-input-number>
                  <span v-else>{{scope.row.price}}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="操作"
                align="center"
                width="160">
                <template slot-scope="scope">
                  <el-button type="primary" style="padding:2px 3px;" plain @click="addLadderData" v-if="scope.$index == 0">确定</el-button>
                  <el-button type="danger" style="padding:2px 3px;" plain @click="delLadderData(scope.$index)" v-else>删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
        </div> -->
        <div class="form-item-wrap">
          <el-form-item :label="'目标' + (addForm.mode == 1 ? '商品' : '客户') + '数量'" prop="num">
            <el-input-number v-model="addForm.num" :min="0"
              style="width:200px;"></el-input-number>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="活动单价" prop="price">
            <el-input-number v-model="addForm.price" :min="0"
              style="width:200px;"></el-input-number>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="最小商品数量" prop="minNum">
            <el-input-number v-model="addForm.minNum" :min="0"
              style="width:200px;"></el-input-number>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="备注" prop="des">
            <el-input v-model="addForm.des" style="width: 200px;"></el-input>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="条件不满足时是否开启" prop="isNoSatisfy">
            <el-select v-model="addForm.isNoSatisfy" placeholder="条件不满足时是否开启活动" 
              style="width:200px;margin-right:5px">
              <el-option label="是" value="0"></el-option>
              <el-option label="否" value="1"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="区域控销" prop="limitArea">
            <el-select v-model="addForm.limitArea" placeholder="区域控销" 
              style="width:200px;margin-right:5px">
              <el-option label="无限制" value="0"></el-option>
              <el-option label="指定白名单" value="1"></el-option>
              <el-option label="指定黑名单" value="2"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="form-item-wrap" v-show="addForm.limitArea != 0">
          <el-form-item label="选择区域" prop="areaValue" class="el-form-required-true">
            <div style="width: 800px;">
              <div>
                <el-tag 
                  v-for="(item,index) in areaList" 
                  :key="index" 
                  closable
                  @close="tagClose(index,'areaValue','areaList')"
                  type="success"
                  effect="dark"
                  :disable-transitions="false"
                  class="my-el-tag"
                  style="margin-bottom: 5px;">{{item.label}}
                </el-tag>
              </div>
              <el-button type="primary" @click="setTableData('area')">增加区域</el-button>
            </div>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="客户控销" prop="limitUser">
            <el-select v-model="addForm.limitUser" placeholder="客户控销" 
              style="width:200px;margin-right:5px">
              <el-option label="无限制" value="0"></el-option>
              <el-option label="指定白名单" value="1"></el-option>
              <el-option label="指定黑名单" value="2"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="form-item-wrap" v-show="addForm.limitUser != 0">
          <el-form-item label="选择客户" prop="userValue" class="el-form-required-true">
            <div style="width: 800px;">
              <div>
                <el-tag 
                  v-for="(item,index) in userList" 
                  :key="index" 
                  closable
                  @close="tagClose(index,'userValue','userList')"
                  type="success"
                  effect="dark"
                  :disable-transitions="false"
                  class="my-el-tag"
                  style="margin-bottom: 5px;">{{item.label}}
                </el-tag>
              </div>
              <el-button type="primary" @click="setTableData('user')">增加客户</el-button>
            </div>
          </el-form-item>
        </div>
        <div class="form-item-wrap">
          <el-form-item label="" prop="">
            <el-button type="primary" @click="submit">提交</el-button>
          </el-form-item>
        </div>
      </el-form>
    </el-scrollbar>

    <!-- 数据选择 -->
    <tableDialog 
      v-if="dialogVisible"
      :title="tableData.title"
      :isMoreSel="tableData.isAllSel"
      :searchValue="searchForm.name"
      :tableData="tableList"
      :tableHead="tableDataHead"
      :currPage.sync="currPage"
      :allPage="allPage"
      @search="getTableData"
      @moreSel="selDataOk"
      @rowClick="rowClick"
      @hanCurrChange="hanCurrChange"
      @close="dialogVisible = false"
    ></tableDialog>
  </div>
</template>

<script>
//表单验证
import { mustFill } from "@/mixins/data/valid.js";

export default {
  name: 'addFocusBuy',
  data() {
    return {
      id: '',
      /**新增表单 */
      addForm:{
        entId: "",// 机构ID
        name:"", // 活动名称
        goodsId:"", // 活动商品
        goodsName:"", // 活动商品名称
        deposit:"", // 单份定金
        startTime:"", // 开始时间
        endTime:"", // 结束时间
        userType:[], // 客户类型
        payType:[], // 支付方式
        isGetPay: true, // 是否是请求过来的entId
        mode:"1", // 达成目标模式
        isLadder:"1", // 是否启用阶梯价格
        // 阶梯数据
        ladder: {
          num: '',
          price: ''
        },
        minNum:"", // 最小商品数量
        num:"", // 目标客户/商品数量
        price:"", // 活动单价
        des:"", // 备注
        isNoSatisfy:"0", // 条件不满足时是否开启活动
        limitArea:"0", // 区域控销
        areaValue:"", // 选择区域
        limitUser:"0", // 客户控销
        userValue:"", // 选择客户
      },
      /**表单规则 */
      addFormRule:{
        name: [mustFill], // 活动名称
        goodsId: [mustFill], // 活动商品
        deposit: [mustFill], // 单份定金
        startTime: [mustFill], // 开始时间
        endTime: [mustFill], // 结束时间
        userType: [mustFill], // 客户类型
        payType: [mustFill], // 支付方式
        mode: [mustFill], // 达成目标模式
        // isLadder: [mustFill], // 是否启用阶梯价格
        price: [mustFill], // 活动单价
        num: [mustFill], // 满足商品数量
        minNum: [mustFill], // 最小商品数量
        isNoSatisfy: [mustFill], // 条件不满足时是否开启活动
        limitArea: [mustFill], // 区域控销
        areaValue: [this.limitFill('limitArea')], // 选择区域
        limitUser: [mustFill], // 客户控销
        userValue: [this.limitFill('limitUser')], // 选择客户
      },
      userTypeList: [],
      payTypeList: [],
      isPayTips: false,
      areaList: [],
      userList: [],
      ladderList: [
        {
          num: '',
          price: ''
        }
      ],
      dialogVisible: false,
      currPage: 1,
      allPage: 0,
      // 表格多选时是否有已选的数据
      isSelDataOkRep: false,
      searchForm: {
        name: ''
      },
      tableData:{
        type: '',
        title: '',
        sqlType: '',
        key: '',
        isAllSel: false,
      },
      tableList: [],
      tableDataHead: {}
    }
  },
  mounted() {
    let prams = JSON.parse(decodeURIComponent(this.$route.query.prams));
    if(prams.id){
      this.id = prams.id
      this.getFocusBuy()
    }else{
      this.addForm.entId = window.localStorage.getItem('entId')
    }
    this.getUserType()
  },
  computed: {
    entId() {
      return this.addForm.entId
    }
  },
  watch: { 
    entId(){
      if(this.addForm.isGetPay){
        this.addForm.isGetPay = false
      }else{
        this.addForm.payType = []
      }
      this.getPayType()
    } 
  },
  methods:{
    goBack() {
      this.$router.go(-1);
      this.$destroy()
    },
    // 获取集采活动详情
    getFocusBuy(){
      let data = {
        type: "GetById",
        id: this.id
      };
      let proc = "Proc_Admin_jicai";//存储过程名
      let type = "ReturnDataSet";
      this.$requestSys({
        method:"post",
        url: "jicai/ashx/ReturnJson.ashx?type=" + type + "&json=" + encodeURIComponent(JSON.stringify(data)) + "&proc=" + proc,
      }).then((res) => {
        if (res.flag == 0) {
          let data = res.table0[0]
          this.addForm.entId = data.entid
          this.addForm.name = data.jcname
          this.addForm.goodsId = data.article_id
          this.addForm.goodsName = data.sub_title
          this.addForm.price = data.price
          this.addForm.deposit = data.deposit
          this.addForm.startTime = new Date(data.starttime)
          this.addForm.endTime = new Date(data.endtime)
          this.addForm.userType = this.$changeStrArr(data.customertype)
          this.addForm.payType = this.$changeStrArr(data.payTypeList)
          this.addForm.isGetPay = true
          this.addForm.mode = data.target_type
          this.addForm.num = data.target_type == 1 ? data.target_goods_num : data.target_customer_num
          this.addForm.isLadder = data.use_jieti
          this.ladderList = this.ladderList.concat((res.table1 || []).map(item => ({num: item.number,price: item.price})))
          this.addForm.minNum = data.min_goods_num
          this.addForm.des = data.remarks
          this.addForm.isNoSatisfy = data.true_success
          this.addForm.limitArea = data.kx_quyu.trim() || '0'
          this.addForm.areaValue = this.$changeStr(data.quyu_id_list)
          this.addForm.limitUser = data.kx_kehu.trim() || '0'
          this.addForm.userValue = this.$changeStr(data.kehu_id_list)

          let valueList = this.$changeStrArr(data.quyu_id_list)
          let labelList = this.$changeStrArr(data.quyu_name_list)
          this.areaList = valueList.map((item,index) => ({label: labelList[index],value: valueList[index]}))
          valueList = this.$changeStrArr(data.kehu_id_list)
          labelList = this.$changeStrArr(data.kehu_name_list)
          this.userList = valueList.map((item,index) => ({label: labelList[index],value: valueList[index]}))
        }else{
          this.$message({
            message: res.message,
            type: 'error'
          });
        }
      }).catch((err) => {
        window.console.log(err)
      });
    },
    // 获取客户类型
    getUserType(){
      let proc = "Proc_Admin_CustomerList";//存储过程名
      let type = "ReturnList";
      let json = {
        type: "CustomType"
      };
      this.$requestSys({
        method:"post",
        url: "coupon/ashx/returnJson.ashx?type=" + type + "&json=" + encodeURIComponent(JSON.stringify(json)) + "&proc=" + proc,
        dataType:"json"
      }).then((res) => {
        if (res.flag == 0) {
          this.userTypeList = res.data.map(item => ({label: item.clienttype,value: item.TypeID}))
        }
      }).catch((err) => {
        window.console.log(err)
      })
    },
    // 获取支付方式
    getPayType(){
      let data = {
        entId: this.addForm.entId
      }
      this.$request({
        url: 'Base/GetEntPayTypeList',
        method: 'post',
        data: data
      }).then(res => {
        if (res.success) {
          this.payTypeList = res.list.map(item => ({label: item.PayType,value: item.PayId + ''}))
          if(this.payTypeList.length){
            this.isPayTips = false
          }else{
            this.isPayTips = true
          }
        }
      }).catch((err) => {
        window.console.log(err)
      })
    },
    // 增加阶梯数据
    addLadderData(){
      this.ladderList.push({
        num: this.addForm.ladder.num,
        price: this.addForm.ladder.price
      })
      this.addForm.ladder = {num: '',price: ''}
    },
    // 删除阶梯数据
    delLadderData(index){
      this.ladderList.splice(index,1)
    },
    // 设置弹框请求数据
    setTableData(type){
      if(type == 'goods'){
        this.tableData.title = '商品列表'
        this.tableData.sqlType = 'GoodsList'
        this.tableData.key = 'sub_title'
        this.tableData.isAllSel = false
      }else if(type == 'area'){
        this.tableData.title = '区域列表'
        this.tableData.sqlType = 'RegionList'
        this.tableData.key = '地址'
        this.tableData.isAllSel = true
      }else if(type == 'user'){
        this.tableData.title = '用户列表'
        this.tableData.sqlType = 'CompanyList'
        this.tableData.key = '单位名称'
        this.tableData.isAllSel = true
      }
      this.tableData.type = type
      this.getTableData()
    },
    // 获取弹出框表格数据
    getTableData(val,isRep){
      this.searchForm.name = isRep ? val : this.searchForm.name
      let data = {
        type: this.tableData.sqlType,
        PageIndex: this.currPage,
        PageSize: 10,
        strWhere: this.searchForm.name,
      };
      let proc = "Proc_Admin_SearchInfo";//存储过程名
      let type = "ReturnDataSet";
      this.$requestSys({
        method:"post",
        url: "ashx/MainReturnJson.ashx?json=" + encodeURIComponent(JSON.stringify(data)) + "&type=" + type + "&proc=" + proc,
      }).then((res) => {
        if (res.flag == 0) {
          this.tableList = res.content
          this.tableDataHead = res.fdname
          this.allPage = res.recordCount
          this.dialogVisible = true
        }else{
          this.$message({
            message: res.message,
            type: 'error'
          });
        }
      }).catch((err) => {
        window.console.log(err)
      });
    },
    /**当前页改变 */
    hanCurrChange(val){
      this.currPage = val;
      this.getTableData()
    },
    // 选择单条数据
    rowClick(row,isSelDataOk){
      if(this.tableData.type == 'goods'){
        this.addForm.goodsId = row.keyid
        // this.addForm.entId = row.entId
        this.addForm.goodsName = row[this.tableData.key]
      }else if(this.tableData.type == 'area' || this.tableData.type == 'user'){
        for(let i = 0; i < this[this.tableData.type + 'List'].length; i++){
          if(this[this.tableData.type + 'List'][i].value == row.keyid){
            if(isSelDataOk === true){
              this.isSelDataOkRep = true
            }else{
              this.$message({
                message: '选择的数据已在列表中',
                type: 'warning'
              });
            }
            return
          }
        }
        this[this.tableData.type + 'List'].push({
          label: row[this.tableData.key],
          value: row.keyid
        })
        this.addForm[this.tableData.type + 'Value'] = this[this.tableData.type + 'List'].map(item => item.value).join()
      }
      this.dialogVisible = false
    },
    // 选择数据完成，多选
    selDataOk(selectedList){
      if(selectedList.length == 0){
        this.$message({
          message: '请选择数据',
          type: 'warning'
        });
        return
      }
      selectedList.forEach(item => {
        this.rowClick(item,true)
      })
      if(this.isSelDataOkRep){
        this.$message({
          message: '选择的数据已在列表中',
          type: 'warning'
        });
        this.isSelDataOkRep = false
      }
    },
    // 标签删除
    tagClose(index,key,keyList){
      this[keyList].splice(index,1)
      this.addForm[key] = this[keyList].map(item => item.value).join()
    },
    // 控销控制验证
    limitFill(key){
      return {validator:(rule, value, callback) => {
        if(this.addForm[key] != 0){
          if(!value){
            return callback(new Error('该字段为必填项'))
          }else{
            return callback()
          }
        }else{
          return callback()
        }
      }}
    },
    /**提交表单 */
    submit(){
      this.$refs['addForm'].validate((valid)=>{
        if (valid) {
          // let list = this.ladderList.slice(1)
          // list = list.map(item => ({mztj: item.num,zk: item.price}))
          // if(!list.length){
          //   this.$message({
          //     message: '请保存至少一条阶梯数据',
          //     type: 'warning'
          //   });
          //   return
          // }
          let data = {
            userId: window.localStorage.getItem('userId'),
            jicaiid: this.id,//集采id
            kx_quyu : this.addForm.limitArea,
            quyu_id_list: this.addForm.areaValue,
            quyu_name_list: this.areaList.map(item => item.label).join(','),
            kx_kehu: this.addForm.limitUser,
            kehu_id_list: this.addForm.userValue,
            kehu_name_list: this.userList.map(item => item.label).join(','),
            jicaiName: this.addForm.name,//集采名称
            startingTime: this.$formatDate(this.addForm.startTime,true),//活动开始时间
            endTime: this.$formatDate(this.addForm.endTime,true),//活动结束时间
            txtArticleId: this.addForm.goodsId,//商品id
            huodongdanjia: this.addForm.price,//活动单价
            danfendingjin: this.addForm.deposit,//单份定金
            khTypeId: this.addForm.userType.join(','),//客户类型
            payTypeList: this.addForm.payType.join(','),//支付类型
            target_type: this.addForm.mode,//目标类型 1商品数量 2客户数量
            target_num: this.addForm.num,//目标数量
            use_jieti: this.addForm.isLadder,//是否使用阶梯
            lsid: JSON.stringify([{ mztj: this.addForm.num, zk: this.addForm.price }]),//阶梯设置
            // lsid: JSON.stringify(list),//阶梯设置
            // huodongdanjia: list[0].zk, // 阶梯价格第一位，活动价格
            min_goods_num: this.addForm.minNum, // 最小商品数量
            remarks: this.addForm.des, // 备注
            success_huodong: this.addForm.isNoSatisfy, // 不满足条件是否开启活动 1是 0否
            entId: this.addForm.entId, // 商品机构ID
          };
          let url = 'JiCai/AddJiCai'
          if(this.id){
            url = "JiCai/UpdateJiCai";
          }
          this.$request({
            method:"post",
            url: url,
            data: data
          }).then((res) => {
            if(res.flag == 0){
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              this.goBack()
            }else{
              this.$message({
                message: res.message,
                type: 'error'
              });
            }
          }).catch((err) => {
            window.console.log(err)
          });
        } else {
          this.$message({
            message: '请补全信息',
            type: 'warning'
          });
        }
      });
    },
  }
}
</script>

<style scoped>
.addFocusBuy{
  width: 100%;
  height: 100%;
}
.payTips{
  font-size: 14px;
  color: #F56C6C;
}
</style>
